/* eslint-disable */

import React from 'react';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import green from 'material-ui/colors/green';
import { CircularProgress } from 'material-ui/Progress';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import Checkbox from '@material-ui/core/Checkbox';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { FormControl, FormHelperText } from 'material-ui/Form';
import { getRequiredErrorMessage } from '../../src/utils/formValidation/ErrorMessages';
import MenuItem from 'material-ui/Menu/MenuItem';
import TextField from 'material-ui/TextField';

import List from 'material-ui/List';
import ListItem from 'material-ui/List/ListItem';
import ListItemSecondaryAction from 'material-ui/List/ListItemSecondaryAction';
import ListItemText from 'material-ui/List/ListItemText';
import ListSubheader from 'material-ui/List/ListSubheader';

import deleteIcon from '../assets/images/icons/delete.png';

import Button from 'material-ui/Button';
import moment from 'moment';
import { withRouter } from 'react-router';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';

import Card, { CardHeader, CardContent } from 'material-ui/Card';
import Grid from 'material-ui/Grid';
import { Row, Col } from 'react-flexbox-grid';

import createIcon from '../assets/images/icons/create.png';
import dataFlowIcon from '../assets/images/icons/data-flow.png';
import companyIcon from '../assets/images/icons/company.png';
import trashIcon from '../assets/images/icons/trash.png';
import plusIcon from '../assets/images/icons/plus.png';

import Typography from 'material-ui/Typography';

import { translate } from 'react-i18next';
import { getTimeZones } from '../../src/utils/timeZone/TimeZones';
import { sanitize } from '../utils/text';

import {
  operationalSinceChanged,
  displayedNameChanged,
  typeChanged,
  capacityChanged,
  registryComplianceChanged,
  locationChanged,
  createAssetProducingStart,
  updateAssetProducingStart,
  getAssetsProducingStart,
  getAssetProducingFormStart,
  resetCurrentAssetProducing,
  uploadAssetPicture,
  prodAssetPictureChanged,
  prodAssetTimeZoneChanged,
  prodAssetDisplayGraphDataChanged,
  assetIdChanged,
  assetNameChanged,
  archiveAssetProducingStart,
  restoreAssetProducingStart,
  getOffchainProdSources,
  getOffchainProdSourceHistory,
  prodAssetOrganizationChanged,
  prodAssetOrganizationsChanged,
  prodAssetCountryChanged,
  getOrganizations,
  getCountries,
} from '../actions';

import {
  checkUserIsAdmin,
  checkUserIsSuperAdmin,
} from '../utils/user/checkAdmin/CheckAdmin';
import InformationPopup from './commons/InformationPopup';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'center',
  },
  margin: {
    margin: theme.spacing.unit,
  },
  withoutLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  textField: {
    flexBasis: 200,
    margin: 20,
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

const assetTypes = [
  {
    value: 1,
    label: 'Solar',
  },
  {
    value: 2,
    label: 'RunRiverHydro',
  },
  {
    value: 3,
    label: 'BiomassGas',
  },
  {
    value: 4,
    label: 'Wind',
  },
  {
    value: 5,
    label: 'Geothermal',
  },
  {
    value: 6,
    label: 'SolidBiomass',
  },
];

const assetCompliances = [
  {
    value: 1,
    label: 'EEC',
  },
  {
    value: 2,
    label: 'TIGR',
  },
  {
    value: 3,
    label: 'GOO',
  },
  {
    value: 4,
    label: 'IREC',
  },
];

const timeZones = getTimeZones();

const periodTypes = [
  {
    value: 'minute',
    label: 'Minute(s)',
  },
  {
    value: 'hour',
    label: 'Hour(s)',
  },
  {
    value: 'day',
    label: 'Day(s)',
  },
];

const aggregationPeriodTypes = [
  {
    value: 'minute',
    label: 'Minute',
  },
  {
    value: 'hour',
    label: 'Hour',
  },
  {
    value: 'day',
    label: 'Day',
  },
  {
    value: 'month',
    label: 'Month',
  },
  {
    value: 'year',
    label: 'Year',
  },
];

class FormAssetsProducing extends React.Component {
  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  state = {
    startDate: '',
    source: '',
    sourceID: '',
    periodNumber: 10,
    periodType: periodTypes[0].value,
    aggregationPeriodNumber: 1,
    aggregationPeriodType: aggregationPeriodTypes[2].value,
    sourceHistory: [],
    prodSources: [],
    prodSourcesList: [],
    sourceIds: [],
    assetType: 'None',
    assetCompliance: 'none',
    address: '',
    organizationId: '',
  };

  componentDidMount = async () => {
    const { isAuthenticated, user } = this.props;
    await populateProdSourcesList(this.state);
    populateSourceIdsList(this.state);

    if (checkUserIsAdmin(isAuthenticated, user)) {
      const {
        match: { params },
      } = this.props;

      await this.props.getOrganizations();
      await this.props.getCountries();

      if (params.assetId) {
        // Update mode
        this.props.getAssetProducingFormStart(params.assetId);
        await populateSourceHistory(this.state, params.assetId);

        let organizationId = '';

        if (this.props.currentAssetProducing.organization) {
          organizationId = this.props.currentAssetProducing.organization._id;
        }

        this.setState({
          organizationId: organizationId,
        });
      } else {
        // Create mode
        this.props.resetCurrentAssetProducing();

        this.setState({
          organizationId: '',
        });
      }
    } else {
      this.props.history.push('/');
    }
  };

  parseGoogleResponse = components => {
    const formattedResult = {
      country: '',
      region: '',
      zip: '',
      city: '',
      street: '',
      houseNumber: '',
      gpsLatitude: '',
      gpsLongitude: '',
    };
    return getLatLng(components).then(gpsCoords => {
      formattedResult.gpsLatitude = gpsCoords.lat;
      formattedResult.gpsLongitude = gpsCoords.lng;

      components.address_components.map(component => {
        component.types.map(type => {
          if (type === 'route') {
            formattedResult.street = component.long_name;
          }
          if (type === 'street_number') {
            formattedResult.houseNumber = component.long_name;
          }
          if (type === 'locality') {
            formattedResult.city = component.long_name;
          }
          if (type === 'administrative_area_level_1') {
            formattedResult.region = component.long_name;
          }
          if (type === 'country') {
            formattedResult.country = component.long_name;
          }
          if (type === 'postal_code') {
            formattedResult.zip = component.long_name;
          }
        });
      });
      return formattedResult;
    });
  };

  handleDisplayGraphDataChange = () => event => {
    this.props.prodAssetDisplayGraphDataChanged(event.target.checked);
  };

  handleAggregationPeriodNumberChange = () => event => {
    this.state.aggregationPeriodNumber = event.target.value;
    this.setState({
      aggregationPeriodNumber: this.state.aggregationPeriodNumber,
    });
  };

  handleAggregationPeriodTypeChange = () => event => {
    this.state.aggregationPeriodType = event.target.value;
    this.setState({ aggregationPeriodType: this.state.aggregationPeriodType });
  };

  handleStartDateChange = newDate => {
    let newStartDate = moment(newDate).format('YYYY-MM-DD');

    this.setState({ startDate: newStartDate });
  };

  handleTimeZoneChange = () => event => {
    this.props.prodAssetTimeZoneChanged(event.target.value);
  };

  handleSourceChange = () => event => {
    this.setState({ source: event.target.value });

    // Init start date with current time
    let newStartDate = moment().format('YYYY-MM-DDTHH:mm');

    this.setState({ startDate: newStartDate });
  };

  handleSourceIdChange = () => event => {
    this.setState({ sourceID: event.target.value });
  };

  addSourceHistoryItem = () => {
    this.state.sourceHistory.push({
      source: this.state.source,
      sourceID: this.state.sourceID,
      startDate: this.state.startDate,
      periodNumber: this.state.periodNumber,
      periodType: this.state.periodType,
      aggregationPeriodNumber: this.state.aggregationPeriodNumber,
      aggregationPeriodType: this.state.aggregationPeriodType,
    });
    this.setState({ sourceHistory: this.state.sourceHistory });
  };

  removeSourceHistoryItem = item => {
    const index = this.state.sourceHistory.indexOf(item);
    this.state.sourceHistory.splice(index, 1);
    this.setState({ sourceHistory: this.state.sourceHistory });
  };

  handleCountryChange = () => event => {
    let country = this.props.countries.find(country => {
      return country._id === event.target.value;
    });

    this.props.prodAssetCountryChanged(country);
  };

  handlePeriodNumberChange = () => event => {
    this.state.periodNumber = event.target.value;
    this.setState({ periodNumber: this.state.periodNumber });
  };

  handlePeriodTypeChange = () => event => {
    this.state.periodType = event.target.value;
    this.setState({ periodType: this.state.periodType });
  };

  handleDisplayedNameChange = () => event => {
    const {
      match: { params },
    } = this.props;

    let displayedName = event.target.value;
    this.props.displayedNameChanged(event.target.value);

    if (!params.assetId) {
      //only on asset creation

      let assetID = sanitize(displayedName);
      this.props.assetNameChanged(assetID);
      this.props.assetIdChanged(assetID);
    }
  };

  handleCapacityChange = () => event => {
    this.props.capacityChanged(event.target.value);
  };

  handleTypeChange = () => event => {
    this.props.typeChanged(event.target.value);
  };

  handleOperationalSinceChange = newDate => {
    this.props.operationalSinceChanged(
      moment(newDate, 'YYYY-MM-DTh:mm').format('x')
    );
  };

  handleComplianceChange = () => event => {
    this.props.registryComplianceChanged(event.target.value);
  };

  handleAddressChange = address => {
    this.setState({ address });
  };

  handleAddressSelect = address => {
    geocodeByAddress(address)
      .then(results => {
        return this.parseGoogleResponse(results[0]);
      })
      .then(formattedAddress => {
        let address = formattedAddress.houseNumber + ' ';
        address += formattedAddress.street
          ? formattedAddress.street + ', '
          : '';
        address += formattedAddress.zip ? formattedAddress.zip + ', ' : '';
        address += formattedAddress.city ? formattedAddress.city + ', ' : '';
        address += formattedAddress.region
          ? formattedAddress.region + ', '
          : '';
        address += formattedAddress.country
          ? formattedAddress.country + ' '
          : '';

        this.setState({ address });
        this.props.locationChanged(formattedAddress);
      })
      .catch(error => console.error('Error', error));
  };

  handleButtonLogout = () => {
    if (!this.props.loading) {
      this.props.logoutStart();
    }
  };

  handlePictureChange = event => {
    this.props.prodAssetPictureChanged(event.target.files[0]);
  };

  onDrop = async file => {
    this.props.uploadAssetPicture(file, this.props.currentAssetProducing.id);
  };

  onAddOrganizationClicked(organization) {
    this.props.currentAssetProducing.organizations.push({
      organization,
      percentage: 0,
    });
    this.props.prodAssetOrganizationsChanged(
      this.props.currentAssetProducing.organizations
    );
  }

  onRemoveOrganizationClicked(organization) {
    let newProdAssetOrganizations = this.props.currentAssetProducing.organizations.filter(
      o => {
        return o.organization._id !== organization._id;
      }
    );
    this.props.prodAssetOrganizationsChanged(newProdAssetOrganizations);
  }
  onOrganizationPercentageChange = organization => event => {
    let newProdAssetOrganizations = this.props.currentAssetProducing.organizations.map(
      o => {
        if (o.organization._id === organization._id)
          o.percentage = event.target.value / 100;
        return o;
      }
    );
    this.props.prodAssetOrganizationsChanged(newProdAssetOrganizations);
  };

  render() {
    const {
      classes,
      isAuthenticated,
      currentAssetProducing,
      loading,
      loadingForm,
      organizations,
      countries,
      match: { params },
      localProdAssetPicture,
      user,
      t,
      cookies,
    } = this.props;

    let csrfToken = cookies.cookies._csrf;
    let dateFormat = 'yyyy/MM/dd'; //English date
    if (this.props.i18n.language === 'fr') {
      dateFormat = 'dd/MM/yyyy';
    } else if (this.props.i18n.language === 'en_us') {
      dateFormat = 'MM/dd/yyyy'; //American date
    }

    let dateTimeFormat = 'YYYY-MM-DD HH:mm'; //English date
    if (this.props.i18n.language === 'fr') {
      dateTimeFormat = 'DD-MM-YYYY HH:mm';
    } else if (this.props.i18n.language === 'en_us') {
      dateTimeFormat = 'MM-DD-YYYY h:mm a'; //American date
    }

    let dateTimeFormat_form = 'yyyy-MM-dd HH:mm'; //English date
    if (this.props.i18n.language === 'fr') {
      dateTimeFormat_form = 'dd-MM-yyyy HH:mm';
    } else if (this.props.i18n.language === 'en_us') {
      dateTimeFormat_form = 'MM-dd-yyyy h:mm a'; //American date
    }

    let isSuperAdmin = checkUserIsSuperAdmin(isAuthenticated, user);

    let updatingAsset = false;
    if (params.assetId) {
      updatingAsset = true;
    }

    const buttonClassname = classNames({
      [classes.buttonSuccess]: loading,
    });

    if (loadingForm || !currentAssetProducing) {
      return <CircularProgress size={24} />;
    }

    if (!organizations || organizations.length < 1) {
      const CONFIGURE_ORGANIZATION_MESSAGE =
        'There is no organization setup, please create at least one organization.';

      return <InformationPopup message={CONFIGURE_ORGANIZATION_MESSAGE} />;
    }

    let fullAddress = currentAssetProducing.houseNumber + ' ';
    fullAddress += currentAssetProducing.street
      ? currentAssetProducing.street + ', '
      : '';
    fullAddress += currentAssetProducing.zip
      ? currentAssetProducing.zip + ', '
      : '';
    fullAddress += currentAssetProducing.city
      ? currentAssetProducing.city + ', '
      : '';
    fullAddress += currentAssetProducing.region
      ? currentAssetProducing.region + ', '
      : '';
    fullAddress += currentAssetProducing.country
      ? currentAssetProducing.country + ' '
      : '';

    let assetProducingSelectedPicture = false;

    if (
      currentAssetProducing &&
      currentAssetProducing.pictureFileName &&
      !localProdAssetPicture
    ) {
      assetProducingSelectedPicture =
        process.env.REACT_APP_API_URL +
        '/static/assets/prod/' +
        currentAssetProducing.pictureFileName;
    } else if (localProdAssetPicture) {
      assetProducingSelectedPicture = URL.createObjectURL(
        localProdAssetPicture
      );
    }

    let availablaOrganizations = organizations.filter(organization => {
      let isNotRelatedToAsset = true;
      this.props.currentAssetProducing.organizations.map(o => {
        if (o.organization && o.organization._id === organization._id)
          isNotRelatedToAsset = false;
      });
      return organization.type === 'utility' && isNotRelatedToAsset;
    });

    let prodAssetOrganizations = this.props.currentAssetProducing.organizations.filter(
      o => {
        return o.organization.type === 'utility';
      }
    );
    return (
      <div className={classes.root}>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Card className={classes.card}>
              <CardHeader
                avatar={<img src={createIcon} style={{ maxHeight: 20 }} />}
                title="Asset information"
              />
              <CardContent>
                <form>
                  <div>
                    <input type="hidden" name="_csrf" value={{ csrfToken }} />
                    <FormControl
                      className={classNames(classes.margin, classes.textField)}
                    >
                      <InputLabel htmlFor="adornment-displayedName">
                        Displayed name
                      </InputLabel>
                      <Input
                        id="adornment-displayedName"
                        type="text"
                        value={
                          currentAssetProducing &&
                          currentAssetProducing.displayedName
                            ? currentAssetProducing.displayedName
                            : ''
                        }
                        autoComplete="displayedName"
                        onChange={this.handleDisplayedNameChange()}
                      />
                    </FormControl>
                    <FormControl
                      className={classNames(classes.margin, classes.textField)}
                    >
                      <TextField
                        id="adornment-name"
                        type="text"
                        disabled={true}
                        label="Ref (can not be modified)"
                        helperText="Used to decrypt blockchain data"
                        value={
                          currentAssetProducing && currentAssetProducing.name
                            ? currentAssetProducing.name
                            : ''
                        }
                      />
                    </FormControl>
                    {isSuperAdmin && (
                      <FormControl
                        className={classNames(
                          classes.margin,
                          classes.textField
                        )}
                      >
                        <TextField
                          id="adornment-asset-id"
                          type="text"
                          label="Asset Id"
                          disabled={true}
                          value={
                            currentAssetProducing &&
                            currentAssetProducing.assetID
                              ? currentAssetProducing.assetID
                              : ''
                          }
                        />
                      </FormControl>
                    )}
                  </div>

                  <div>
                    <PlacesAutocomplete
                      value={
                        this.state.address ? this.state.address : fullAddress
                      }
                      onChange={this.handleAddressChange}
                      onSelect={this.handleAddressSelect}
                    >
                      {({
                        getInputProps,
                        suggestions,
                        getSuggestionItemProps,
                      }) => (
                        <FormControl
                          className={classNames(
                            classes.margin,
                            classes.textField
                          )}
                          style={{ width: '100%' }}
                        >
                          <InputLabel htmlFor="adornment-location">
                            Location
                          </InputLabel>
                          <Input
                            id="adornment-location"
                            {...getInputProps({
                              placeholder: 'Search Places ...',
                              className: 'location-search-input',
                            })}
                          />
                          <div className="autocomplete-dropdown-container">
                            {suggestions.map(suggestion => {
                              const className = suggestion.active
                                ? 'suggestion-item--active'
                                : 'suggestion-item';
                              const style = suggestion.active
                                ? {
                                    backgroundColor: '#fafafa',
                                    cursor: 'pointer',
                                    width: 'auto',
                                    color: 'rgba(0, 0, 0, 1)',
                                    height: 24,
                                    overflow: 'hidden',
                                    fontSize: '1rem',
                                    boxSizing: 'content-box',
                                    fontWeight: 'bold',
                                    lineHeight: '1.5em',
                                    fontFamily:
                                      '"Inter-Regular", "Avenir", "Roboto", "Helvetica", "Arial", sans-serif',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    paddingLeft: 16,
                                    paddingRight: 16,
                                    paddingTop: 12,
                                    paddingBottom: 12,
                                  }
                                : {
                                    backgroundColor: '#ffffff',
                                    cursor: 'pointer',
                                    width: 'auto',
                                    color: 'rgba(0, 0, 0, 0.87)',
                                    height: 24,
                                    overflow: 'hidden',
                                    fontSize: '1rem',
                                    boxSizing: 'content-box',
                                    fontWeight: 400,
                                    lineHeight: '1.5em',
                                    fontFamily:
                                      '"Inter-Regular", "Avenir", "Roboto", "Helvetica", "Arial", sans-serif',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    paddingLeft: 16,
                                    paddingRight: 16,
                                    paddingTop: 12,
                                    paddingBottom: 12,
                                  };
                              return (
                                <div
                                  {...getSuggestionItemProps(suggestion, {
                                    className,
                                    style,
                                  })}
                                >
                                  <span>{suggestion.description}</span>
                                </div>
                              );
                            })}
                          </div>
                        </FormControl>
                      )}
                    </PlacesAutocomplete>
                  </div>
                  <div>
                    <TextField
                      id="select-type"
                      select
                      label="Asset type"
                      className={classes.textField}
                      value={
                        currentAssetProducing && currentAssetProducing.assetType
                          ? currentAssetProducing.assetType
                          : ' '
                      }
                      onChange={this.handleTypeChange()}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {assetTypes.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      id="select-compliance"
                      select
                      label="Registry compliance"
                      className={classes.textField}
                      value={
                        currentAssetProducing &&
                        currentAssetProducing.registryCompliance
                          ? currentAssetProducing.registryCompliance
                          : ' '
                      }
                      onChange={this.handleComplianceChange()}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                      style={{ width: 140 }}
                    >
                      {assetCompliances.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>

                    <TextField
                      id="select-time-zone"
                      select
                      label="Time zone "
                      validators={['isRequired']}
                      errormessages={[getRequiredErrorMessage()]}
                      className={classes.textField}
                      value={
                        currentAssetProducing &&
                        currentAssetProducing.momentTimezone
                          ? currentAssetProducing.momentTimezone
                          : ' '
                      }
                      onChange={this.handleTimeZoneChange()}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                      style={{ width: 140 }}
                    >
                      {timeZones.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.value}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                  <div>
                    <FormControl
                      className={classNames(classes.margin, classes.textField)}
                    >
                      <InputLabel htmlFor="adornment-capacity">
                        Maximum capacity (W)
                      </InputLabel>
                      <Input
                        id="adornment-capacity"
                        type="text"
                        value={
                          currentAssetProducing &&
                          currentAssetProducing.capacityWh
                            ? currentAssetProducing.capacityWh
                            : ''
                        }
                        autoComplete="capacity"
                        onChange={this.handleCapacityChange()}
                      />
                    </FormControl>

                    <TextField
                      id="select-countries"
                      select
                      label={t('Country')}
                      className={classes.textField}
                      value={
                        currentAssetProducing.countryLink &&
                        currentAssetProducing.countryLink._id
                          ? currentAssetProducing.countryLink._id
                          : ''
                      }
                      onChange={this.handleCountryChange()}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                      style={{ flexBasis: 'auto', width: 88 }}
                    >
                      {countries.map(country => (
                        <MenuItem key={country._id} value={country._id}>
                          {country.name}
                        </MenuItem>
                      ))}
                    </TextField>

                    <FormControl
                      className={classNames(classes.margin, classes.textField)}
                    >
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          format={dateTimeFormat_form}
                          openTo={'year'}
                          label="Operational since"
                          value={
                            currentAssetProducing && currentAssetProducing.id
                              ? moment(currentAssetProducing.operationalSince)
                              : moment()
                          }
                          onChange={newDate => {
                            if (!moment(newDate).isValid() || !newDate) {
                              newDate = null;
                            }

                            this.handleOperationalSinceChange(newDate);
                          }}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                          className={classes.inputWithMargin}
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </div>

                  <Grid item xs={12}>
                    <Row>
                      <Col>
                        <input
                          accept="image/*"
                          className={classes.input}
                          id="upload-button-file"
                          multiple
                          type="file"
                          style={{ display: 'none' }}
                          onChange={this.handlePictureChange.bind(this)}
                          onDrop={this.onDrop.bind(this)}
                        />
                        <label htmlFor="upload-button-file">
                          <div style={{ marginLeft: 20, marginRight: 20 }}>
                            <Button
                              variant="flat"
                              color="primary"
                              component="span"
                              className={classes.button}
                              disabled={loading}
                              style={{
                                marginTop: 13,
                                border: '1px solid rgba(248,119,51, 0.5)',
                                borderRadius: 4,
                              }}
                            >
                              Select Picture
                            </Button>
                          </div>
                        </label>
                      </Col>
                      <Col style={{ marginLeft: 10 }}>
                        {assetProducingSelectedPicture && (
                          <img
                            src={assetProducingSelectedPicture}
                            style={{
                              height: 60,
                              width: 60,
                              borderRadius: '50%',
                            }}
                          />
                        )}
                        {!assetProducingSelectedPicture && (
                          <Typography
                            color="inherit"
                            variant="caption"
                            style={{ marginTop: 23 }}
                          >
                            No picture selected
                          </Typography>
                        )}
                      </Col>
                    </Row>
                  </Grid>
                  <Grid item xs={12}>
                    <Row>
                      <Col>
                        <Checkbox
                          checked={
                            currentAssetProducing &&
                            currentAssetProducing.displayGraphData !== undefined
                              ? currentAssetProducing.displayGraphData
                              : true
                          }
                          value="primary"
                          onChange={this.handleDisplayGraphDataChange()}
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                          style={{ marginLeft: 10 }}
                        />
                      </Col>
                      <Col>
                        <Typography
                          color="inherit"
                          variant="caption"
                          style={{ marginTop: 13 }}
                        >
                          Display graph data for customer
                        </Typography>
                      </Col>
                    </Row>
                  </Grid>
                </form>
              </CardContent>
            </Card>
            <br />
            <Card className={classes.card}>
              <CardHeader
                avatar={<img src={companyIcon} style={{ maxHeight: 20 }} />}
                title="Organizations"
              />
              <CardContent>
                <Grid item xs={12}>
                  <Row>
                    <Col xs={6}>
                      <List dense>
                        <ListSubheader>Available Organizations</ListSubheader>
                        {availablaOrganizations.map(organization => (
                          <ListItem
                            key={'available-organizations-' + organization._id}
                          >
                            <ListItemText
                              primary={organization.name}
                              secondary="available : 100%"
                            />
                            <ListItemSecondaryAction>
                              <Button
                                onClick={() => {
                                  this.onAddOrganizationClicked(organization);
                                }}
                              >
                                <img src={plusIcon} style={{ maxHeight: 20 }} />
                              </Button>
                            </ListItemSecondaryAction>
                          </ListItem>
                        ))}
                      </List>
                    </Col>
                    <Col xs={6}>
                      <List dense>
                        <ListSubheader>
                          Asset related organizations
                        </ListSubheader>
                        {prodAssetOrganizations.map(o => (
                          <ListItem
                            key={
                              'asset-related-to-current-organization-' +
                              o.organization._id
                            }
                          >
                            <ListItemText primary={o.organization.name} />
                            <ListItemSecondaryAction>
                              <Button
                                onClick={() => {
                                  this.onRemoveOrganizationClicked(
                                    o.organization
                                  );
                                }}
                              >
                                <img
                                  src={trashIcon}
                                  style={{ maxHeight: 20 }}
                                />
                              </Button>
                            </ListItemSecondaryAction>

                            <FormControl
                              className={classNames(
                                classes.margin,
                                classes.textField
                              )}
                            >
                              <Input
                                id={
                                  'adornment-percentage-' + o.organization._id
                                }
                                type="number"
                                value={
                                  o && o.percentage ? o.percentage * 100 : 0
                                }
                                onChange={this.onOrganizationPercentageChange(
                                  o.organization
                                )}
                                autoComplete="percentage"
                                style={{ width: 60 }}
                                endAdornment={
                                  <InputAdornment position="end">
                                    %
                                  </InputAdornment>
                                }
                                inputProps={{
                                  'aria-label': 'Allocated percentage',
                                }}
                              />
                              <FormHelperText id="weight-helper-text">
                                Allocated percentage
                              </FormHelperText>
                            </FormControl>
                          </ListItem>
                        ))}
                      </List>
                    </Col>
                  </Row>
                </Grid>
              </CardContent>
            </Card>
            <br />
            <Card className={classes.card}>
              <CardHeader
                avatar={<img src={dataFlowIcon} style={{ maxHeight: 20 }} />}
                title="Data acquisition"
              />
              <CardContent>
                <List dense>
                  {currentAssetProducing.source &&
                    currentAssetProducing.sourceID &&
                    currentAssetProducing.periodNumber &&
                    currentAssetProducing.periodType &&
                    currentAssetProducing.aggregationPeriodNumber &&
                    currentAssetProducing.aggregationPeriodType && (
                      <div>
                        <ListSubheader>{'Current source : '}</ListSubheader>
                        <ListItem
                          key={'current-source-' + currentAssetProducing._id}
                        >
                          <ListItemText
                            secondary="(Source)"
                            primary={
                              currentAssetProducing.source
                                ? currentAssetProducing.source
                                : ''
                            }
                          />
                          <ListItemText
                            secondary="(Source id)"
                            primary={
                              currentAssetProducing.sourceID
                                ? currentAssetProducing.sourceID
                                : ''
                            }
                          />
                          <ListItemText
                            secondary="(Aquisition)"
                            primary={
                              currentAssetProducing.periodNumber &&
                              currentAssetProducing.periodType
                                ? currentAssetProducing.periodNumber +
                                  ' ' +
                                  currentAssetProducing.periodType
                                : ''
                            }
                          />
                          <ListItemText
                            secondary="(Aggregation)"
                            primary={
                              currentAssetProducing.aggregationPeriodNumber &&
                              currentAssetProducing.aggregationPeriodType
                                ? currentAssetProducing.aggregationPeriodNumber +
                                  ' ' +
                                  currentAssetProducing.aggregationPeriodType
                                : ''
                            }
                          />
                        </ListItem>
                      </div>
                    )}
                  {!currentAssetProducing.source && (
                    <ListSubheader>
                      {'Current source : No current source yet'}
                    </ListSubheader>
                  )}

                  {this.state.sourceHistory &&
                    this.state.sourceHistory.length > 0 && (
                      <ListSubheader>{'Source history : '}</ListSubheader>
                    )}
                  {this.state.sourceHistory &&
                    this.state.sourceHistory.length === 0 && (
                      <ListSubheader>{'No source history'}</ListSubheader>
                    )}

                  {this.state.sourceHistory.map(item => (
                    <ListItem
                      key={
                        'source-history-' +
                        item.source +
                        '-' +
                        item.sourceID +
                        '-' +
                        moment(item.startDate).format('YYYY-MM-DDTHH:mm')
                      }
                    >
                      <ListItemText
                        secondary="(Source)"
                        primary={item.source}
                      />

                      <ListItemText
                        secondary="(Source id)"
                        primary={item.sourceID}
                      />

                      <ListItemText
                        secondary="(Aquisition)"
                        primary={item.periodNumber + ' ' + item.periodType}
                      />
                      <ListItemText
                        secondary="(Aggregation)"
                        primary={
                          item.aggregationPeriodNumber +
                          ' ' +
                          item.aggregationPeriodType
                        }
                      />

                      <ListItemText
                        secondary="Start date"
                        primary={moment(item.startDate).format(dateTimeFormat)}
                      />

                      <ListItemSecondaryAction>
                        <Button
                          onClick={() => this.removeSourceHistoryItem(item)}
                        >
                          <img src={deleteIcon} style={{ maxHeight: 20 }} />
                        </Button>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                  <ListSubheader>{'Create a new source : '}</ListSubheader>
                </List>
                <form style={{ backgroundColor: '#fafafa', paddingBottom: 20 }}>
                  <div>
                    <div>
                      <TextField
                        id="select-source"
                        select
                        label="Source"
                        className={classes.textField}
                        value={this.state.source}
                        onChange={this.handleSourceChange()}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        style={{ width: 100 }}
                        margin="normal"
                      >
                        {this.state.prodSourcesList.map(option => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.value}
                          </MenuItem>
                        ))}
                      </TextField>

                      <FormControl
                        className={classNames(
                          classes.margin,
                          classes.textField
                        )}
                      >
                        <InputLabel htmlFor="adornment-source-id">
                          Source ID
                        </InputLabel>
                        <Input
                          id="adornment-source-id"
                          type="text"
                          value={this.state.sourceID}
                          autoComplete="Source ID"
                          onChange={this.handleSourceIdChange()}
                        />
                      </FormControl>

                      <FormControl
                        className={classNames(
                          classes.margin,
                          classes.textField
                        )}
                      >
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            format={dateFormat}
                            openTo={'year'}
                            label="Start date"
                            value={
                              this.state.startDate
                                ? this.state.startDate
                                : moment().format('YYYY-MM-DD')
                            }
                            onChange={newDate => {
                              if (!moment(newDate).isValid() || !newDate) {
                                newDate = null;
                              }

                              this.handleStartDateChange(newDate);
                            }}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            className={classes.inputWithMargin}
                          />
                        </MuiPickersUtilsProvider>
                      </FormControl>
                    </div>
                    <Grid item xs={12}>
                      <Row
                        style={{
                          marginLeft: 20,
                          marginRight: 20,
                          marginTop: 30,
                        }}
                      >
                        <Col xs={6}>
                          <Row>
                            <Typography
                              className={classes.title}
                              variant="body2"
                              gutterBottom
                              color="textSecondary"
                              style={{ fontSize: '0.875rem' }}
                            >
                              Acquisition frequency
                            </Typography>
                          </Row>
                          <Row>
                            <div>
                              <div style={{ float: 'left', marginTop: 25 }}>
                                <Typography
                                  className={classes.title}
                                  variant="body1"
                                  gutterBottom
                                  color="textSecondary"
                                  component="span"
                                  style={{
                                    fontSize: '0.875rem',
                                    float: 'left',
                                  }}
                                >
                                  Acquire data every
                                </Typography>
                              </div>
                              <div style={{ float: 'left' }}>
                                <FormControl
                                  className={classNames(
                                    classes.margin,
                                    classes.textField
                                  )}
                                >
                                  <Input
                                    style={{ fontSize: '13px', width: 40 }}
                                    id="adornment-period-number"
                                    type="text"
                                    value={
                                      this.state.periodNumber
                                        ? this.state.periodNumber
                                        : ''
                                    }
                                    autoComplete="Period number"
                                    onChange={this.handlePeriodNumberChange()}
                                  />
                                </FormControl>
                                <TextField
                                  style={{ fontSize: '13px', width: 140 }}
                                  id="select-period-type"
                                  select
                                  className={classes.textField}
                                  value={
                                    this.state.periodType
                                      ? this.state.periodType
                                      : periodTypes
                                  }
                                  onChange={this.handlePeriodTypeChange()}
                                  SelectProps={{
                                    MenuProps: {
                                      className: classes.menu,
                                    },
                                  }}
                                  margin="normal"
                                >
                                  {periodTypes.map(option => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </div>
                            </div>
                          </Row>
                        </Col>
                        <Col xs={6}>
                          <Row>
                            <Typography
                              className={classes.title}
                              variant="body2"
                              gutterBottom
                              color="textSecondary"
                              style={{ fontSize: '0.875rem' }}
                            >
                              Aggregation frequency
                            </Typography>
                          </Row>

                          <Row>
                            <div>
                              <div style={{ float: 'left', marginTop: 25 }}>
                                <Typography
                                  className={classes.title}
                                  variant="body1"
                                  gutterBottom
                                  color="textSecondary"
                                  component="span"
                                  style={{
                                    fontSize: '0.875rem',
                                    float: 'left',
                                  }}
                                >
                                  Aggregate metering every
                                </Typography>
                              </div>
                              <div style={{ float: 'left' }}>
                                <FormControl
                                  className={classNames(
                                    classes.margin,
                                    classes.textField
                                  )}
                                >
                                  <Input
                                    id="adornment-aggregation-period-number"
                                    type="text"
                                    style={{ fontSize: '13px', width: 40 }}
                                    value={
                                      this.state.aggregationPeriodNumber
                                        ? this.state.aggregationPeriodNumber
                                        : ''
                                    }
                                    autoComplete="Aggregation Period Number"
                                    onChange={this.handleAggregationPeriodNumberChange()}
                                  />
                                </FormControl>
                                <TextField
                                  id="select-aggragation-period-type"
                                  select
                                  className={classes.textField}
                                  value={
                                    this.state.aggregationPeriodType
                                      ? this.state.aggregationPeriodType
                                      : ' '
                                  }
                                  onChange={this.handleAggregationPeriodTypeChange()}
                                  SelectProps={{
                                    MenuProps: {
                                      className: classes.menu,
                                    },
                                  }}
                                  margin="normal"
                                >
                                  {aggregationPeriodTypes.map(option => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </div>
                            </div>
                          </Row>
                        </Col>
                      </Row>
                    </Grid>
                    <div style={{ marginLeft: 20, marginRight: 20 }}>
                      <Button
                        variant="flat"
                        color="primary"
                        component="span"
                        className={classes.button}
                        disabled={loading}
                        style={{
                          marginTop: 13,
                          border: '1px solid rgba(248,119,51, 0.5)',
                          borderRadius: 4,
                        }}
                        onClick={this.addSourceHistoryItem}
                      >
                        Add this source
                      </Button>
                    </div>
                  </div>
                </form>
              </CardContent>
            </Card>

            <div
              className={classes.wrapper}
              style={{ margin: 20, float: 'right' }}
            >
              <Button
                variant="raised"
                color="primary"
                className={buttonClassname}
                disabled={loading}
                onClick={() => {
                  updatingAsset
                    ? this.props.updateAssetProducingStart(
                        this.props.currentAssetProducing,
                        this.props.localProdAssetPicture,
                        this.props.history,
                        this.state.sourceHistory
                      )
                    : this.props.createAssetProducingStart(
                        this.props.currentAssetProducing,
                        this.props.localProdAssetPicture,
                        this.props.history,
                        this.state.sourceHistory
                      );
                }}
              >
                {updatingAsset ? 'Update asset' : 'Create asset'}
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}{' '}
              {updatingAsset &&
                currentAssetProducing &&
                !currentAssetProducing.active && (
                  <Button
                    variant="raised"
                    color="secondary"
                    className={buttonClassname}
                    disabled={loading}
                    onClick={() =>
                      this.props.restoreAssetProducingStart(
                        this.props.currentAssetProducing,
                        this.props.history
                      )
                    }
                  >
                    Restore asset
                  </Button>
                )}
              {updatingAsset &&
                currentAssetProducing &&
                currentAssetProducing.active && (
                  <Button
                    variant="raised"
                    color="secondary"
                    className={buttonClassname}
                    disabled={loading}
                    onClick={() =>
                      this.props.archiveAssetProducingStart(
                        this.props.currentAssetProducing,
                        this.props.history
                      )
                    }
                  >
                    Archive asset
                  </Button>
                )}
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

FormAssetsProducing.contextTypes = {
  router: PropTypes.object,
};
FormAssetsProducing.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({
  assetsProducingReducer,
  router,
  loginReducer,
  organizationsReducer,
  countriesReducer,
}) => {
  const {
    assetsProducing,
    currentAssetProducing,
    loading,
    loadingForm,
    localProdAssetPicture,
  } = assetsProducingReducer;
  const { location } = router;
  const { organizations } = organizationsReducer;
  const { countries } = countriesReducer;
  const { isAuthenticated, username, user } = loginReducer;
  return {
    assetsProducing,
    currentAssetProducing,
    loading,
    loadingForm,
    location,
    isAuthenticated,
    username,
    localProdAssetPicture,
    user,
    organizations,
    countries,
  };
};

const mapDispatchToProps = {
  operationalSinceChanged,
  displayedNameChanged,
  typeChanged,
  capacityChanged,
  registryComplianceChanged,
  locationChanged,
  createAssetProducingStart,
  updateAssetProducingStart,
  getAssetsProducingStart,
  getAssetProducingFormStart,
  resetCurrentAssetProducing,
  uploadAssetPicture,
  prodAssetPictureChanged,
  prodAssetTimeZoneChanged,
  prodAssetDisplayGraphDataChanged,
  assetIdChanged,
  assetNameChanged,
  archiveAssetProducingStart,
  restoreAssetProducingStart,
  prodAssetOrganizationChanged,
  prodAssetOrganizationsChanged,
  prodAssetCountryChanged,
  getOrganizations,
  getCountries,
};

FormAssetsProducing = withStyles(styles, { name: 'FormAssetsProducing' })(
  FormAssetsProducing
);
FormAssetsProducing = translate('translations')(FormAssetsProducing);

/*Helper functions*/
const populateProdSourcesList = async state => {
  state.prodSources = await getOffchainProdSources('Production');

  state.prodSourcesList = state.prodSources.map(s => {
    return { value: s.name };
  });
};

const populateSourceIdsList = state => {
  let sourceIdsArray = [];
  for (let s of state.prodSources) {
    for (let asset of s.assets) sourceIdsArray.push(asset.id);
  }
  state.sourceIds = sourceIdsArray.map(AssetId => {
    return { value: AssetId };
  });
};

const populateSourceHistory = async (state, assetId) => {
  state.sourceHistory = await getOffchainProdSourceHistory(assetId);
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withCookies(FormAssetsProducing))
);



// WEBPACK FOOTER //
// ./src/components/FormAssetsProducing.js